import FilterValueAdapter from "@viz-ui/models/storyboardFilter/filterValueAdapter";
import FieldValueManager from "./fieldValueManager.service";
import FieldValueStore from "./fieldValueStore.service";

angular
  .module("acl.visualizer.fieldValue", ["acl.common.config", "acl.common.dataRequester", "acl.visualizer.charts"])
  .service("FieldValueManager", FieldValueManager)
  .service("FieldValueStore", () => FieldValueStore)
  .factory("FilterValueAdapter", () => FilterValueAdapter);
